/**
 * Fixed, with no per-user selector. Measuring the detail pane's own height was rejected: there is
 * nothing to measure before a record is chosen, and a page count that shifts as a beheerder
 * browses is its own kind of confusing.
 */
export const FULL_PAGE_SIZE = 15;
export const MODAL_PAGE_SIZE = 10;

/**
 * The backend's own ceiling (`PagingDefaults.MaxPageSize`), which covers every whole-set caller:
 * korpsen are the largest at ~154 nationally.
 */
export const UNPAGINATED_FETCH_SIZE = 200;

/**
 * `format: int32` reaches the client as `string | number`, though never a string on the wire.
 * One cast here rather than at every read site.
 */
export function toNumber(value: number | string): number {
  return typeof value === "number" ? value : Number(value);
}
